/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogItemReportsDTO,
  CatalogItemReportsDTOOptional,
  CatalogItemReportsDTOMetaI,
  CatalogItemReportsDTOTrackedI,
} from "./catalog-item-reports-dto";
import {
  CatalogItemReportsDTOTracked,
  CatalogItemReportsDTOMeta,
} from "./catalog-item-reports-dto";

/**
 *
 * @export
 * @interface CatalogItemReportsResultDTO
 */
export interface CatalogItemReportsResultDTOOptional {
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportsResultDTO
   */
  queueId?: string;
  /**
   *
   * @type {CatalogItemReportsDTO}
   * @memberof CatalogItemReportsResultDTO
   */
  catalogItemReports?: CatalogItemReportsDTOOptional;
}

export interface CatalogItemReportsResultDTO extends CatalogItemReportsResultDTOOptional {
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportsResultDTO
   */
  queueId?: string;
  /**
   *
   * @type {CatalogItemReportsDTO}
   * @memberof CatalogItemReportsResultDTO
   */
  catalogItemReports?: CatalogItemReportsDTO;
}

export interface CatalogItemReportsResultDTOTrackedI {
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportsResultDTO
   */
  queueId?: string;
  queueIdIsSet: boolean;
  /**
   *
   * @type {CatalogItemReportsDTO}
   * @memberof CatalogItemReportsResultDTO
   */
  catalogItemReports?: CatalogItemReportsDTOTrackedI;
  catalogItemReportsIsSet: boolean;
}

transformDatesMap.set(
  "CatalogItemReportsResultDTO",
  function (model: CatalogItemReportsResultDTO) {
    const transformDatescatalogItemReports = transformDatesMap.get(
      "CatalogItemReportsDTO",
    );
    if (transformDatescatalogItemReports && model.catalogItemReports) {
      transformDatescatalogItemReports(model.catalogItemReports);
    }
  },
);

export type CatalogItemReportsResultDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  queueId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  catalogItemReports: PropertyMeta<CatalogItemReportsDTOMetaI>;
}>;

export var CatalogItemReportsResultDTOMeta: CatalogItemReportsResultDTOMetaI =
  {} as CatalogItemReportsResultDTOMetaI;
CatalogItemReportsResultDTOMeta = typeMeta("CatalogItemReportsResultDTO", {
  queueId: propertyMeta("queueId", false, false, false, MetaTypesBase.string),
  catalogItemReports: propertyMeta(
    "catalogItemReports",
    false,
    false,
    false,
    CatalogItemReportsDTOMeta,
  ),
});

const metaI = CatalogItemReportsResultDTOMeta;

registerMeta(() => {});

export class CatalogItemReportsResultDTOTracked implements CatalogItemReportsResultDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  queueId__I?: string = undefined;
  queueIdIsSet: boolean = false;
  set queueId(v: undefined | string) {
    if (v !== undefined) {
      this.queueId__I = v;
      this.queueIdIsSet = true;
    } else {
      this.queueId__I = v || undefined;
      this.queueIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get queueId() {
    return this.queueId__I;
  }
  catalogItemReports__I?: CatalogItemReportsDTOTracked = undefined;
  catalogItemReportsIsSet: boolean = false;
  set catalogItemReports(v: undefined | CatalogItemReportsDTOTracked) {
    if (v !== undefined) {
      this.catalogItemReports__I = v;
      this.catalogItemReportsIsSet = true;
    } else {
      this.catalogItemReports__I = v || undefined;
      this.catalogItemReportsIsSet = false;
    }
    this.changeTracker = true;
  }
  get catalogItemReports() {
    return this.catalogItemReports__I;
  }
  constructor(
    config?: CatalogItemReportsResultDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.catalogItemReports?.setIds();
  }
  assignFrom(
    config: CatalogItemReportsResultDTOOptional,
    options?: AssignOptions,
  ): CatalogItemReportsResultDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.queueId && this.queueIdApplyFilter(optionsRequired.filter)) {
      this.queueId = config.queueId;
      if (optionsRequired.unassign) this.queueIdIsSet = false;
      else this.queueIdIsSet = true;
    }
    if (
      config.catalogItemReports &&
      this.catalogItemReportsApplyFilter(optionsRequired.filter)
    ) {
      this.catalogItemReports = new CatalogItemReportsDTOTracked(
        config.catalogItemReports,
        options,
      );
      if (optionsRequired.unassign) this.catalogItemReportsIsSet = false;
      else this.catalogItemReportsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CatalogItemReportsResultDTOTrackedI {
    const cloned = {} as CatalogItemReportsResultDTOTrackedI;
    if (
      this.queueIdIsSetDeep() &&
      this.queueIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.queueIdIsSet = true;
      cloned.queueId = this.queueId;
    } else {
      //cloned.queueIdIsSet = false
    }
    if (
      this.catalogItemReportsIsSetDeep() &&
      this.catalogItemReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.catalogItemReportsIsSet = true;
      cloned.catalogItemReports = this.catalogItemReports?.removeUnset(filter);
    } else {
      //cloned.catalogItemReportsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CatalogItemReportsResultDTOTrackedI {
    if (!this.queueIdApplyFilter(filter)) this.queueIdIsSet = false;

    if (!this.catalogItemReportsApplyFilter(filter))
      this.catalogItemReportsIsSet = false;
    this.catalogItemReports?.unassignAll(filter);

    return this;
  }
  queueIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemReportsResultDTOMeta.queueId,
      CatalogItemReportsResultDTOMeta,
      this.queueId,
      this,
    );
  }
  queueIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.queueIdIsSet && this.queueIdApplyFilter(filter)) return true;

    return false;
  }
  catalogItemReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemReportsResultDTOMeta.catalogItemReports,
      CatalogItemReportsResultDTOMeta,
      this.catalogItemReports,
      this,
    );
  }
  catalogItemReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.catalogItemReportsIsSet &&
      this.catalogItemReportsApplyFilter(filter)
    )
      return true;
    return this.catalogItemReports?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.queueIdIsSetDeep(filter)) return true;
    if (this.catalogItemReportsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
